<template>
  <div class="youtube-container">
    <iframe
      :width="playerWidth"
      :height="playerHeight"
      :src="iframeSrc"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      @error="handleError"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'Youtube',
  props: {
    videoId: {
      type: String,
      required: true
    },
    playerWidth: {
      type: [String, Number],
      default: 640
    },
    playerHeight: {
      type: [String, Number],
      default: 360
    }
  },
  computed: {
    iframeSrc() {
      return `https://www.youtube.com/embed/${this.videoId}`;
    }
  },
  methods: {
    handleError(event) {
      this.$emit('error', event);
    }
  }
}
</script>

<style scoped>
.youtube-container {
  display: inline-block;
}
</style>
